class GPSCoordinates {

    private _latitude: number;
    private _longitude: number;

    constructor(latitude: number, longitude: number) {
        this._latitude = latitude;
        this._longitude = longitude;
    }

    get latitude(): number {
        return this._latitude;
    }

    set latitude(value: number) {
        this._latitude = value;
    }

    get longitude(): number {
        return this._longitude;
    }

    set longitude(value: number) {
        this._longitude = value;
    }

    private isLatValid(): boolean {
        return GPSCoordinates.isLatValid(this.latitude);
    }

    private isLongValid(): boolean {
        return GPSCoordinates.isLongValid(this.longitude);
    }

    public isValid(): boolean {
        return (this.isLongValid() && this.isLatValid());
    }

    static isLatValid(numberToCheck: number): boolean {
        let isValid = false;
        if(numberToCheck >= -90 && numberToCheck <= 90) {
            isValid = true;
        }
        return isValid;
    }

    static isLongValid(numberToCheck: number): boolean {
        let isValid = false;
        if(numberToCheck >= -180 && numberToCheck <= 180) {
            isValid = true;
        }
        return isValid;
    }

    static isArrayValidGeoPoint(arrayToCheck: number[]): boolean {
        let isValid = false;
        if(arrayToCheck.length === 2 && this.isLatValid(arrayToCheck[0]) && this.isLongValid(arrayToCheck[1])){
            isValid = true;
        }
        return isValid;
    }

    static remapObjectToGPSCoordinate(objectToRemap: any): GPSCoordinates | null {
        let coordinates: GPSCoordinates | null = null;
        if(objectToRemap._latitude && objectToRemap._longitude) {
            const tempCoordinates = new GPSCoordinates(objectToRemap._latitude, objectToRemap._longitude);
            if(tempCoordinates.isValid()) {
                coordinates = tempCoordinates;
            }
        }
        return coordinates;
    }


}

export default GPSCoordinates;
